import xs from "xstream/index";
import { NEW_APPLICATION_CLIENT_ID, NEW_BASE_URL } from "../config";
import * as ActionTypes from "../actions/types";
import * as actions from "../actions";
import sampleCombine from "xstream/extra/sampleCombine";
import { generalHeader } from "./headers";
import v4 from "uuid/v4";
import { updateUserTypeField } from "../authentication/actions";

const REQUEST_FETCH_USER_TYPES = "requestFetchUserTypes";
const REQUEST_CREATE_USER_QUESTIONNAIRE = "requestCreateUserQuestionnaire";
const REQUEST_UPDATE_USER_QUESTIONNAIRE = "requestUpdateUserQuestionnaire";

export function requestFetchUserTypes(sources) {
  const state$ = sources.STATE;
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);
  const userId$ = state$.map((state) => state.applicationUser?.uuid);

  const request$ = sources.ACTION.filter((action) => {
    return action.type === ActionTypes.FETCH_USER_TYPES;
  })
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => {
      const requestBody = {
        Header: {
          id: v4(),
          application: NEW_APPLICATION_CLIENT_ID,
          bank: "NBG",
          userId: userId || "123e4567-e89b-12d3-a456-426614174000",
        },
        Payload: {
          PageLimit: 10,
          PageOffset: 0,
          SortField: "Name",
          SortOrder: "ASC",
        },
      };

      return {
        url: NEW_BASE_URL + "/UserType/list",
        category: REQUEST_FETCH_USER_TYPES,
        method: "POST",
        headers: generalHeader(csrfToken, true),
        send: requestBody,
        withCredentials: true,
      };
    });

  const httpResponse$ = sources.HTTP.select(REQUEST_FETCH_USER_TYPES)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200
        ? actions.fetchUserTypesSuccess(response.body?.payload?.data || [])
        : actions.fetchUserTypesFailed(response.body || response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

export function createUserQuestionnaire(sources) {
  const state$ = sources.STATE;
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);
  const userId$ = state$.map((state) => state.applicationUser?.uuid);

  const request$ = sources.ACTION.filter((action) => {
    return action.type === ActionTypes.CREATE_USER_QUESTIONNAIRE;
  })
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => {
      console.log(
        "📝 CSRF Token:",
        csrfToken ? "Present" : "Missing",
        csrfToken
      );
      console.log("👤 User ID:", userId);
      const payload = action.payload || {};
      const requestBody = {
        Header: {
          id: v4(),
          application: NEW_APPLICATION_CLIENT_ID,
          bank: "NBG",
          userId: userId || "123e4567-e89b-12d3-a456-426614174000",
        },
        Payload: {
          Title: payload.title || `Questionnaire for user ${userId}`,
          Langcode: payload.langcode || "en",
          Status: payload.status !== undefined ? payload.status : true,
          Sticky: payload.sticky !== undefined ? payload.sticky : false,
          Promote: payload.promote !== undefined ? payload.promote : false,
          UrlAlias: payload.urlAlias || null,
          Published: payload.published !== undefined ? payload.published : true,
          ProductCategories: payload.productCategories || "",
          CompanyLegalName: payload.companyLegalName || "",
          CompanyTaxNumber: payload.companyTaxNumber || "",
          CompanyWebsite: payload.companyWebsite || "",
          CompanyKad: payload.companyKad || "",
          CompanyOwnsBankAccount:
            payload.companyOwnsBankAccount !== undefined
              ? payload.companyOwnsBankAccount
              : false,
          CompanyRepFullName: payload.companyRepFullName || "",
          CompanyRepNumber: payload.companyRepNumber || "",
          CompanyReprEmail: payload.companyReprEmail || "",
          CompanyUsesErp:
            payload.companyUsesErp !== undefined
              ? payload.companyUsesErp
              : false,
          CompanyErpSolutionName: payload.companyErpSolutionName || "",
          CompanyErpSolutionVersion: payload.companyErpSolutionVersion || "",
          ErpBankingActivities: payload.erpBankingActivities || "",
          CorporateUserId: userId || "123e4567-e89b-12d3-a456-426614174000",
          ConsentInformation:
            payload.consentInformation !== undefined
              ? payload.consentInformation
              : true,
          UserTypeId: payload.userTypeId || "CORPORATE",
        },
      };

      return {
        url: NEW_BASE_URL + "/UserQuestionnaire/create",
        category: REQUEST_CREATE_USER_QUESTIONNAIRE,
        method: "POST",
        headers: generalHeader(csrfToken, true),
        send: requestBody,
        withCredentials: true,
      };
    });

  const httpResponse$ = sources.HTTP.select(REQUEST_CREATE_USER_QUESTIONNAIRE)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200 || response.status === 201
        ? actions.createUserQuestionnaireSuccess(response.body)
        : actions.createUserQuestionnaireFailed(response.body || response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

export function updateUserQuestionnaire(sources) {
  const state$ = sources.STATE;
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);
  const userId$ = state$.map((state) => state.applicationUser?.uuid);

  const request$ = sources.ACTION.filter((action) => {
    return action.type === ActionTypes.UPDATE_USER_QUESTIONNAIRE;
  })
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => {
      const payload = action.payload || {};
      console.log({ payload });
      const requestBody = {
        Header: {
          id: v4(),
          application: NEW_APPLICATION_CLIENT_ID,
          bank: "NBG",
          userId: userId || "123e4567-e89b-12d3-a456-426614174000",
        },
        Payload: {
          Id: payload.id,
          Title: payload.title || `Questionnaire for user ${userId}`,
          Langcode: payload.langcode || "en",
          Status: payload.status !== undefined ? payload.status : true,
          Sticky: payload.sticky !== undefined ? payload.sticky : false,
          Promote: payload.promote !== undefined ? payload.promote : false,
          UrlAlias: payload.urlAlias || null,
          Published: payload.published !== undefined ? payload.published : true,
          ProductCategories: payload.productCategories || "",
          CompanyLegalName: payload.companyLegalName || "",
          CompanyTaxNumber: payload.companyTaxNumber || "",
          CompanyWebsite: payload.companyWebsite || "",
          CompanyKad: payload.companyKad || "",
          CompanyOwnsBankAccount:
            payload.companyOwnsBankAccount !== undefined
              ? payload.companyOwnsBankAccount
              : false,
          CompanyRepFullName: payload.companyRepFullName || "",
          CompanyRepNumber: payload.companyRepNumber || "",
          CompanyReprEmail: payload.companyReprEmail || "",
          CompanyUsesErp:
            payload.companyUsesErp !== undefined
              ? payload.companyUsesErp
              : false,
          CompanyErpSolutionName: payload.companyErpSolutionName || "",
          CompanyErpSolutionVersion: payload.companyErpSolutionVersion || "",
          ErpBankingActivities: payload.erpBankingActivities || "",
          CorporateUserId: userId || "123e4567-e89b-12d3-a456-426614174000",
          ConsentInformation:
            payload.consentInformation !== undefined
              ? payload.consentInformation
              : true,
          UserTypeId: payload.userTypeId || "CORPORATE",
        },
      };

      return {
        url: NEW_BASE_URL + "/UserQuestionnaire/update",
        category: REQUEST_UPDATE_USER_QUESTIONNAIRE,
        method: "POST",
        headers: generalHeader(csrfToken, true),
        send: requestBody,
        withCredentials: true,
      };
    });

  const httpResponse$ = sources.HTTP.select(REQUEST_UPDATE_USER_QUESTIONNAIRE)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) =>
      response.status === 200 || response.status === 201
        ? actions.updateUserQuestionnaireSuccess(response.body)
        : actions.updateUserQuestionnaireFailed(response.body || response)
    );

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

// Handle questionnaire success to close modal and update user state
export function handleQuestionnaireSuccess(sources) {
  const state$ = sources.STATE;

  // Listen for successful questionnaire creation
  const createSuccess$ = sources.ACTION.filter(
    (action) => action.type === ActionTypes.CREATE_USER_QUESTIONNAIRE_SUCCESS
  )
    .compose(sampleCombine(state$))
    .map(([action, state]) => {
      const questionnaireId = action.payload?.payload?.id;
      const userType = state.userQuestionaire?.selectedUserType || "CORPORATE";
      const isEdit = state.userQuestionaire?.isEdit;
      const isOpen = state.userQuestionaire?.isOpen;

      // Prepare actions to close modal and update user
      const actionsToDispatch = [];

      // Update user type with questionnaire ID
      if (questionnaireId) {
        actionsToDispatch.push(
          updateUserTypeField({
            userType: userType,
            questionaireId: questionnaireId,
          })
        );
      }

      // Close the modal based on current state
      if (isEdit) {
        actionsToDispatch.push(actions.editQuestionaire(false));
      } else if (isOpen) {
        actionsToDispatch.push(actions.openQuestionaire(false));
      }

      return xs.from(actionsToDispatch);
    })
    .flatten();

  // Listen for successful questionnaire update
  const updateSuccess$ = sources.ACTION.filter(
    (action) => action.type === ActionTypes.UPDATE_USER_QUESTIONNAIRE_SUCCESS
  )
    .compose(sampleCombine(state$))
    .map(([action, state]) => {
      const isEdit = state.userQuestionaire?.isEdit;
      const isOpen = state.userQuestionaire?.isOpen;

      // Close the modal based on current state
      if (isEdit) {
        return actions.editQuestionaire(false);
      } else if (isOpen) {
        return actions.openQuestionaire(false);
      }
      return xs.never();
    })
    .filter((action) => action !== xs.never());

  return {
    ACTION: xs.merge(createSuccess$, updateSuccess$),
  };
}

// Combine all questionnaire cycles into a single default export
export default function questionnaireCycles(sources) {
  const userTypes = requestFetchUserTypes(sources);
  const create = createUserQuestionnaire(sources);
  const update = updateUserQuestionnaire(sources);
  const handleSuccess = handleQuestionnaireSuccess(sources);

  return {
    ACTION: xs.merge(
      userTypes.ACTION,
      create.ACTION,
      update.ACTION,
      handleSuccess.ACTION
    ),
    HTTP: xs.merge(userTypes.HTTP, create.HTTP, update.HTTP),
  };
}
